<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_iv"></a><a id="Copyright"><img alt="" class="image" src="images/f.jpg"/><br/><br/>
<i>Artillery of the Napoleonic Wars: Artillery in Siege, Fortress and Navy</i><br/>
This edition published in 2015 by Frontline Books,<br/>
an imprint of Pen &amp; Sword Books Ltd,<br/>
47 Church Street, Barnsley, S. Yorkshire, S70 2AS<br/>
</a><a href="http://www.frontline-books.com" target="_blank">www.frontline-books.com</a></p>
<p class="copyright3">Copyright © Kevin Kiley, 2015</p>
<p class="copyright3">The right of Kevin Kiley to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copyright3">ISBN: 978-1-84832-637-8<br/>
EPUB ISBN: 978-1-47384-874-0<br/>
PRC ISBN: 978-1-47384-875-7</p>
<p class="copyright3">All rights reserved. No part of this publication may be reproduced, stored in or introduced into a retrieval system, or transmitted, in any form, or by any means (electronic, mechanical, photocopying, recording or otherwise) without the prior written permission of the publisher. Any person who does any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p class="copyright3">CIP data records for this title are available from the British Library</p>
<p class="copyright3">For more information on our books, please visit <a href="http://www.frontline-books.com" target="_blank">www.frontline-books.com</a>, email <a href="mailto:info@frontline-books.com">info@frontline-books.com</a> or write to us at the above address.</p>
<p class="copyright3">Printed and bound by CPI Group (UK) Ltd, Croydon CR0 4YY</p>
<p class="copyright3">Typeset in 11/13 pt Bembo</p>
<p class="space"> </p>
<p class="copyright3"><i>Title page:</i> A proposed design for a battering piece to enable firing from above the parapet of the covered way of a fortress. From Louis de Tousard’s <i>American Artillerist’s Companion.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?73870815